import { render, staticRenderFns } from "./SkipItem.vue?vue&type=template&id=6436168a&"
import script from "./SkipItem.vue?vue&type=script&lang=js&"
export * from "./SkipItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6436168a')) {
      api.createRecord('6436168a', component.options)
    } else {
      api.reload('6436168a', component.options)
    }
    module.hot.accept("./SkipItem.vue?vue&type=template&id=6436168a&", function () {
      api.rerender('6436168a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/financial/reconciliation/santander/pix/components/SkipItem.vue"
export default component.exports